module.exports = __webpack_public_path__ + "img/ch50.0ff180f3.jpg";